module.exports = __webpack_public_path__ + "assets/yokohama-bottom-left.448cb5e0.svg";